<div class="panelGeofences" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}" >
  <loading [isLoading]="isLoading"></loading>
  <div class="btnClose">
   <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="ClosePanel()"></mat-icon>
  </div>
  <!-- componente de reportes -->
  <div class="header_panel">
    <h1 class="titlePanel">Geocercas</h1>
  </div>
  <!-- <div class="btnMenuSecondary">
    <app-report-list [reportes]="false" [editGeofences]="true" ></app-report-list>
  </div> -->
  

  <div class="search-Arrow-flex">
    <div class="searchBar-flex">
      <div class="searchBar">
        <mat-form-field class="width-input">
          <input
            matInput
            placeholder="Búsqueda por Nombre"
            spellcheck="false"
            required
            type="text"
            [(ngModel)]="finder"
            (keyup)="onFindGeofence($event)"
          />
        </mat-form-field>
      </div>
      <div (click)="onFindGeofence($event)">
        <img class="btnSearchIcon" src="/assets/img/icon_search.png" width="25px">
      </div>
    </div>
    
    <div *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_up</mat-icon>
    </div>
    <div *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_down</mat-icon>
    </div>
   </div>

   <div class="button-tool-list">
    <div class="col-10" id="panelGeofencesButtonTool">
      <location-button-toolbar [isGeofencePanel]="true"></location-button-toolbar>
    </div>

    <div class="col-2">
      <!-- <div class="tool-option" >
        <app-report-list [reportes]="false"></app-report-list>
      </div> -->
    </div>
  </div>

  <div class="center-item filter-list" *ngIf="filter">
    <div class="center-item">
      <div class="section-header-background">
        <h3>Resultado de búsqueda </h3> 
      </div>
    </div>
    <div class="control-items">
      <h3 class="no-result-title" *ngIf="$Items.length == 0">No se encontraron elementos</h3>
      <div class="center-item itemPanel" *ngFor="let item of $Items" (click)="onCardClicked(item.id)">
        <div class="row">
          <div class="col-3 img-item">
            <a *ngIf="$ItemsActives.includes(item)"><img [src]="'geocercarOnline.png' | findUrl" width="25px"></a>
            <a *ngIf="$ItemsInactives.includes(item)"><img [src]="'geocercarOffline.png' | findUrl" width="25px"></a>
          </div>
          <div class="row-item col-7">
            <label class="title-item">{{ item.name }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="geofences-tab-group" id="panelGeofencesTabs">
    <mat-tab-group *ngIf="!filter" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectTab($event)" >

      <!-- primer tab -->
      <mat-tab>
        
        <ng-template mat-tab-label >
          <label matTooltipPosition="above">
            <img src="/assets/img/icon_activos.png" width="25px"> Activas </label>
        </ng-template>
        <ng-template matTabContent >
            <!-- Geocercas activas -->
             <div class="tab-content-wrapper">
              <div class="">
                <div class="row">
                  <h3 class="no-result-title" *ngIf="$ItemsActives.length == 0 && !isLoading">No se encontraron elementos</h3>
                  <div class="itemPanel" *ngFor="let item of $ItemsActives" (click)="onCardClicked(item.id)">
                    <div class="row">
                      <div class="col-3 img-item">
                        <a><img [src]="'geocercarOnline.png' | findUrl" width="25px"></a>
                      </div>
                      <div class="row-item col-9">
                        <label class="title-item">{{ item.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             </div>
        </ng-template>
      </mat-tab>
  
      <!-- segundo tab -->
      <mat-tab>
        <ng-template mat-tab-label >
          <label matTooltipPosition="above">
            <img src="/assets/img/icon_inactivos.png" width="25px"> Inactivas </label>
        </ng-template>
        <ng-template matTabContent >
            <!-- Geocercas inactivas -->
            <div class="tab-content-wrapper">
              <div class="">
                <div class="row">
                  <h3 class="no-result-title" *ngIf="$ItemsInactives.length == 0 && !isLoading">No se encontraron elementos</h3>
                  <div class="itemPanel" *ngFor="let item of $ItemsInactives" (click)="onCardClicked(item.id)">
                    <div class="row">
                      <div class="col-3 img-item">
                        <a><img [src]="'geocercarOffline.png' | findUrl" width="25px"></a>
                      </div>
                      <div class="row-item col-9">
                        <label class="title-item">{{ item.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </ng-template>
      </mat-tab>
  
    </mat-tab-group>
  </div>

</div>
